export const FooterLogoImg = () => {
  return (
    <svg
      width='115'
      height='21'
      viewBox='0 0 115 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.09324 20.7051V2.44803H0V0.324438H14.439V2.44803H8.40347V20.7051H6.09324Z'
        fill='#2E2E34'
      />
      <path
        d='M24.0163 21C21.9371 21 20.3199 20.6067 19.1648 19.8202C18.0289 19.0337 17.23 17.8736 16.7679 16.3399C16.3251 14.7865 16.1037 12.8792 16.1037 10.618C16.1037 8.35674 16.3348 6.43961 16.7968 4.86657C17.2588 3.29354 18.0578 2.0941 19.1937 1.26826C20.3488 0.422753 21.9563 0 24.0163 0C26.0762 0 27.6741 0.412921 28.81 1.23876C29.9651 2.06461 30.7737 3.27388 31.2358 4.86657C31.6978 6.43961 31.9288 8.35674 31.9288 10.618C31.9288 12.9382 31.6978 14.875 31.2358 16.4284C30.793 17.9621 29.994 19.1124 28.8389 19.8792C27.703 20.6264 26.0955 21 24.0163 21ZM24.0163 18.9059C25.5372 18.9059 26.6923 18.611 27.4816 18.0211C28.271 17.4312 28.81 16.5267 29.0988 15.3076C29.3876 14.0688 29.532 12.5056 29.532 10.618C29.532 8.78932 29.3779 7.24579 29.0699 5.98736C28.7811 4.70927 28.2421 3.74579 27.4528 3.09691C26.6634 2.42837 25.5179 2.0941 24.0163 2.0941C22.5146 2.0941 21.3691 2.42837 20.5798 3.09691C19.7905 3.74579 19.2418 4.69944 18.9338 5.95787C18.645 7.21629 18.5006 8.76966 18.5006 10.618C18.5006 12.4466 18.645 13.9803 18.9338 15.2191C19.2225 16.4382 19.7616 17.3624 20.5509 17.9916C21.3403 18.6011 22.4954 18.9059 24.0163 18.9059Z'
        fill='#2E2E34'
      />
      <path
        d='M35.9762 20.7051V0.324438H40.2791L47.7873 18.611H48.3649V0.324438H50.6751V20.7051H46.4589L38.8352 2.41854H38.2865V20.7051H35.9762Z'
        fill='#2E2E34'
      />
      <path
        d='M59.5625 20.7051V2.44803H53.4693V0.324438H67.9082V2.44803H61.8727V20.7051H59.5625Z'
        fill='#2E2E34'
      />
      <path
        d='M67.351 20.7051L72.8089 0.324438H77.8048L83.2338 20.7051H80.9236L79.5086 15.5435H71.0762L69.6612 20.7051H67.351ZM71.5672 13.4494H79.0177L76.0432 2.33006H74.5416L71.5672 13.4494Z'
        fill='#2E2E34'
      />
      <path
        d='M86.3152 20.7051V0.324438H88.6254V9.76264L91.8886 9.64466L96.9134 0.324438H99.5702L93.939 10.559L99.8878 20.7051H97.1444L91.9175 11.7388L88.6254 11.8567V20.7051H86.3152Z'
        fill='#2E2E34'
      />
      <path
        d='M102.785 20.7051V0.324438H115V2.41854H105.095V9.32022H113.267V11.3848H105.095V18.611H115V20.7051H102.785Z'
        fill='#2E2E34'
      />
    </svg>
  );
};
